'use client';

import React from 'react';

const products = [
  {
    id: 'emerald',
    name: 'Emerald',
    description: '12% ERC-free repayments',
  },
  {
    id: 'classic',
    name: 'Classic',
    description: '10% ERC-free repayments',
  },
  {
    id: 'sovereign',
    name: 'Sovereign',
    description: '10% ERC-free repayments',
  },
  {
    id: 'heritage',
    name: 'Heritage',
    description: '10% ERC-free repayments',
  },
];

export const ProductSelection = ({ formData, handleRadioChange }) => {
  return (
    <>
      <p className="text-base text-[#000] font-medium mb-8">
        Product (Please select which product you want to calculate the annual overpayment amount for):
      </p>

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">
        {products.map((product) => (
          <div key={product.id} className="flex items-start mb-4">
            <input
              id={product.id}
              type="radio"
              value={formData[product.id]}
              name={product.id}
              checked={formData.selectedProduct === product.id}
              onChange={() => handleRadioChange(product.id)}
              className="w-4 h-4 mt-1 mr-2"
            />
            <label
              htmlFor={product.id}
              className="text-[#0C0D1A] text-[0.875rem] font-semibold"
            >
              {product.name}<br />
              <span className="text-[#5B5D6B] font-450">{product.description}</span>
            </label>
          </div>
        ))}
      </div>
    </>
  );
};
